import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import {
  initCookieBar,
  initDmcabadge,
  initGooglePreferredSource,
} from "../component/bottom-cookie-bar.js";
import initMobileMenu from "../component/mobile-menu.js";
import { initNewsletterModal } from "../component/custom-newsletter-popup.js";


initDmcabadge();
initCookieBar();
initGooglePreferredSource();
initOfficeHoverReveal();
initMobileMenu();
initNewsletterModal();
